import { useIntl } from 'react-intl';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';

type WorkflowsSettingsHeaderProps = Pick<HeaderProps, 'scrollableDivRef'>;

export const WorkflowsSettingsHeader = (
  props: WorkflowsSettingsHeaderProps
) => {
  const intl = useIntl();

  const title = intl.formatMessage({
    id: 'features.workflows.settings.header.title',
  });

  return (
    <Header
      {...props}
      breadcrumbs={<SettingsBreadcrumbs breadcrumbs={[{ label: title }]} />}
      title={title}
      description={intl.formatMessage({
        id: 'features.workflows.settings.header.description',
      })}
    />
  );
};
